import { Spinner } from './Spinner';

interface PageLoadingStateProps {
    /** Minimum height in pixels. Default: 400 */
    minHeight?: number;
    /** Optional loading text (spinner-only by default) */
    text?: string;
}

/**
 * Standardized page-level loading state.
 * Use for initial page loads when no cached data exists.
 *
 * @example
 * // Basic usage (spinner only)
 * if (isLoading) {
 *     return (
 *         <Layout>
 *             <PageLoadingState />
 *         </Layout>
 *     );
 * }
 *
 * @example
 * // With custom min-height
 * <PageLoadingState minHeight={300} />
 */
export function PageLoadingState({ minHeight = 400, text }: PageLoadingStateProps) {
    return (
        <div
            className="flex items-center justify-center"
            style={{ minHeight: `${minHeight}px` }}
        >
            <div className="flex flex-col items-center gap-3">
                <Spinner size="lg" />
                {text && (
                    <p className="text-sm text-gray-500 dark:text-gray-400">
                        {text}
                    </p>
                )}
            </div>
        </div>
    );
}
